import type { IconData } from '@stacksjs/iconify-core'

export const travelCar2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 7h.019A6.5 6.5 0 0 1 12.98 7H16v5a3 3 0 0 1-5.83 1H5.83A3.001 3.001 0 0 1 0 12z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default travelCar2
